import API from './index';
import AppUrls from '../config/AppUrls';
import { buildPathWithParams } from '../utils/Paths';

class AuthenticationService {
  static validateToken(token) {
    const url = `${AppUrls.api.validateToken}?token=${token}`;
    return API.get(url).then((response) => {
      return response.data;
    });
  }

  static login(username, password) {
    return API.post(AppUrls.api.login, { username, password }).then((response) => {
      return response.data;
    });
  }

  static signIn(password, confirmPassword) {
    return API.post(AppUrls.api.signIn, { password, confirmPassword }).then((response) => response.data);
  }

  static forgotPass(username) {
    return API.post(AppUrls.api.forgotPass, { username }).then((response) => response.data);
  }

  static resetPass(password, confirmPassword) {
    return API.put(AppUrls.api.resetPass, { password, confirmPassword }).then((response) => response.data);
  }

  static authenticateMFA(data) {
    return API.post(AppUrls.api.authMfa, data).then((response) => response.data);
  }

  static activateMFA(code) {
    return API.post(AppUrls.api.activationMfa, { mfaCode: code }).then((response) => response.data);
  }

  static logout() {
    return API.delete(AppUrls.api.logout).then((response) => {
      return response.data;
    });
  }

  static signUp(data) {
    return API.post(AppUrls.api.signUp, { ...data }).then((response) => {
      return response.data;
    });
  }

  static getQRUrl() {
    return API.get(AppUrls.api.getQRUrl).then((response) => {
      return response.data;
    });
  }

  static resetMFA(code) {
    return API.put(AppUrls.api.resetMfa, { mfaCode: code }).then((response) => response.data);
  }

  static switchContext(idMerchant, data) {
    const url = buildPathWithParams(AppUrls.api.switchContext, { idMerchant });
    return API.post(url, { ...data }).then((response) => response.data);
  }
}

export default AuthenticationService;
